const parseMultiSelectValue = questionValue => {
  try {
    const parsed = JSON.parse(questionValue || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

function FeedbackDetailsList({ question, index }) {
  const renderAnswer = () => {
    switch (question.questionType) {
      case 'text':
        return <p className="questionValue questionValueText">{question?.questionValue || '—'}</p>;
      case 'rating':
        return (
          <p className="questionValue questionValueRating">{question?.questionValue || '—'}</p>
        );
      case 'multiSelect':
      default: {
        const selected = parseMultiSelectValue(question?.questionValue);
        if (!selected.length) {
          return <p className="questionValue">—</p>;
        }
        return (
          <div className="answerChips">
            {selected.map(name => (
              <span key={name} className="answerChip">
                {name}
              </span>
            ))}
          </div>
        );
      }
    }
  };

  return (
    <div className="questionContainer">
      <h3 className="questionDescription">
        {index}) {question.questionDescription}
      </h3>
      {renderAnswer()}
    </div>
  );
}

export default FeedbackDetailsList;
